module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.seller.id) ? _c('div', {
    staticClass: "step-container"
  }, [_c('div', {
    staticClass: "custom-steps"
  }, [_c('ul', {
    staticClass: "step-indicator"
  }, _vm._l((_vm.steps), function(step, index) {
    return _c('li', {
      class: {
        'current-step': _vm.currentstep === index + 1
      }
    }, [_c('span', {
      staticClass: "step-number"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('button', {
      staticClass: "steps-btn",
      attrs: {
        "title": _vm.$t('wizard.step.company_data')
      }
    }, [_vm._v(_vm._s(step.title))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "steps-main"
  }, [(_vm.currentstep == 1) ? _c('div', {
    staticClass: "steps-content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('wizard.step.info')))]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "ls-box ls-box-gray ls-md-space"
  }, [_c('fieldset', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-block",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('sellers.trade_name'))
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label ls-label-text",
    attrs: {
      "for": "trade-name"
    }
  }, [_vm._v(_vm._s(_vm.$t('wizard.step.company_name')))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-lg-6"
  }, [_c('div', {
    staticClass: "ls-prefix-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.seller.trade_name),
      expression: "seller.trade_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('wizard.step.ph_pegasus_ag'),
      "name": _vm.$t('sellers.trade_name')
    },
    domProps: {
      "value": (_vm.seller.trade_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.seller.trade_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('sellers.trade_name'))),
      expression: "errors.has($t('sellers.trade_name'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('sellers.trade_name'))))])])]), _vm._v(" "), _c('div', {
    staticClass: "input-block",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('sellers.phone'))
    }
  }, [_c('label', {
    staticClass: "col-sm-3 control-label ls-label-text",
    attrs: {
      "for": "contact[number]"
    }
  }, [_vm._v(_vm._s(_vm.$t('wizard.step.phone')))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-lg-6"
  }, [_c('div', {
    staticClass: "ls-prefix-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.full_phone),
      expression: "full_phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:14'),
      expression: "'required|min:14'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "maxlength": "16",
      "placeholder": _vm.$t('wizard.step.ph_phone'),
      "name": _vm.$t('sellers.phone')
    },
    domProps: {
      "value": (_vm.full_phone)
    },
    on: {
      "keyup": _vm.formatPhone,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.full_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('sellers.phone'))),
      expression: "errors.has($t('sellers.phone'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('sellers.phone'))))])])]), _vm._v(" "), _c('div', {
    staticClass: "input-block",
    class: [{
      'ls-error': _vm.errors.has(_vm.$t('sellers.email'))
    }, {
      'ls-success': !_vm.errors.has(_vm.$t('sellers.email')) && _vm.emailChanged
    }]
  }, [_c('label', {
    staticClass: "col-sm-3 control-label ls-label-text",
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t('wizard.step.email')))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-lg-6"
  }, [_c('div', {
    staticClass: "ls-prefix-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.seller.email),
      expression: "seller.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": _vm.$t('wizard.step.ph_email'),
      "name": _vm.$t('sellers.email')
    },
    domProps: {
      "value": _vm.seller.email,
      "value": (_vm.seller.email)
    },
    on: {
      "keyup": _vm.setEmailChanged,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.seller.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('sellers.email'))),
      expression: "errors.has($t('sellers.email'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('sellers.email'))))]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.errors.has(_vm.$t('sellers.email')) && _vm.emailChanged),
      expression: "!errors.has($t('sellers.email')) && emailChanged"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.$t('settings.label.messages.email_available')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ls-actions-btn"
  }, [_c('button', {
    ref: "btnEdit",
    staticClass: "ls-btn-primary ls-float-right ls-no-margin",
    attrs: {
      "type": "button",
      "disabled": this.errors.any()
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v(_vm._s(_vm.$t('wizard.step.btn_next')))])])])]) : _vm._e(), _vm._v(" "), (_vm.currentstep == 2) ? _c('div', {
    staticClass: "steps-content"
  }, [_c('div', {
    staticClass: "ls-box ls-box-gray ls-md-space"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8"
  }, [_c('h4', {
    staticClass: "ls-title-4 ls-md-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('wizard.step.configure_payments_title')))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('wizard.step.configure_payments_text'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "ls-actions-btn"
  }, [_c('button', {
    staticClass: "ls-btn ls-float-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(_vm._s(_vm.$t('wizard.step.back')))]), _vm._v(" "), _c('button', {
    staticClass: "ls-btn-primary ls-float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goNext
    }
  }, [_vm._v(_vm._s(_vm.$t('wizard.step.got_it')))])])]) : _vm._e(), _vm._v(" "), (_vm.currentstep == 3) ? _c('div', {
    staticClass: "steps-content"
  }, [_c('div', {
    staticClass: "ls-box ls-box-gray ls-txt-center ls-lg-space"
  }, [_c('h4', {
    staticClass: "ls-title-4 ls-md-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('wizard.step.endpage_title')))]), _vm._v(" "), _c('p', {
    staticClass: "ls-md-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('wizard.step.endpage_text')))]), _vm._v(" "), _c('a', {
    staticClass: "ls-btn-primary",
    attrs: {
      "href": "javacsript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goToPlans($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('wizard.step.btn_create_plan')))])])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ls-label-text-prefix"
  }, [_c('i', {
    staticClass: "fa fa-building",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ls-label-text-prefix"
  }, [_c('i', {
    staticClass: "fa fa-phone",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ls-label-text-prefix"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "banks"
  }, [_c('img', {
    attrs: {
      "src": require("./../../../assets/img/payment.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19fc6235"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/wizard/Steps.vue
// module id = 732
// module chunks = 1